import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from '@/components/home/home'
import header from '@/components/header/header'
import introduce from '@/components/aboutMe/introduce'
import experience from '@/components/aboutMe/experience'
import contact from '@/components/aboutMe/contact'
import address from '@/components/aboutMe/address'
import business from '@/components/aboutMe/business'
import brand from '@/components/brand/brand'
import work from '@/components/project/work'
import success from '@/components/project/success'
import buy from '@/components/buy/buy'
import hiring from '@/components/addMe/hiring'
import agency from '@/components/addMe/agency'
import myheadert from '@/components/header/header_0'
import loginin from '@/components/loginin/loginIn'
import selectAgency from '@/components/loginin/selectAgency'
// import demo from '@/components/demo/demo1'
import bleft from '@/components/aboutMe/businessleft'
import showBrand from '@/components/brand/showBrand'
import education from '@/components/education/education'
import soft from '@/components/soft/soft'
// import demo from '@/components/demo/demo'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    // {
    //     path: '/demo',
    //     name: 'demo',
    //     component: demo
    // },
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/header',
      name: 'header',
      component: header
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: introduce
    },
    {
      path: '/experience',
      name: 'experience',
      component: experience
    },
    {
      path: '/brand',
      name: 'brnad',
      component: brand
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/address',
      name: 'address',
      component: address
    },
    {
      path: '/work',
      name: 'work',
      component: work
    },
    {
      path: '/buy',
      name: 'buy',
      component: buy
    },
    {
      path: '/hiring',
      name: 'hiring',
      component: hiring
    },
    {
      path: '/agency',
      name: 'agency',
      component: agency
    },
    {
      path: '/business',
      name: 'business',
      component: business
    },
    {
      path: '/success',
      name: 'success',
      component: success
    },
    {
      path: '/myheadert',
      name: 'headert',
      component: myheadert
    },
    {
      path: '/loginin',
      name: 'loginin',
      component: loginin
    },
    {
      path: '/selectAgency',
      name: 'selectAgency',
      component: selectAgency
    },
    {
      path: '/businessleft',
      name: 'businessleft',
      component: bleft
    },
    {
      path: '/showBrand',
      name: 'showBrand',
      component: showBrand
    },
    {
      path: '/education',
      name: 'education',
      component: education
    },
    {
      path: '/soft',
      name: 'soft',
      component: soft
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js